import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { UpdateVendedorDTO, Vendedor, VendedorCombos, VendedorQuery } from '../model/vendedor';
import { url } from '../diccionarios';
import { Cliente } from 'src/app/model/shorts';

@Injectable({
  providedIn: 'root'
})
export class VendedorService {
  private urlDatosMaestros: string;

  constructor(
    private _commom: CommonService,
    private _util: UtilsService
  ) {
    this.urlDatosMaestros = this._util.getDatosMaestros();
  }

  getAll(query: Partial<VendedorQuery>): Observable<Vendedor[]> {
    return this._commom.peticionGetConHeader(`${this.urlDatosMaestros}/${url}?idRol=${query.idRol}`);
  }

  getById(id: string): Observable<Vendedor> {
    return this._commom.peticionGetConHeader(`${this.urlDatosMaestros}/${url}/${id}`);
  }

  update(data: UpdateVendedorDTO, id: string) {
    return this._commom.peticionPutConHeader(`${this.urlDatosMaestros}/${url}/${id}`, data);
  }

  combos(): Observable<VendedorCombos> {
    return this._commom.peticionGetConHeader(`${this.urlDatosMaestros}/${url}/combos`);
  }

  supervisores(): Observable<Cliente[]> {
    return this._commom.peticionGetConHeader(`${this.urlDatosMaestros}/cliente/supervisores`);
  }

  vendedorCsv(body: FormData) {
    return this._commom.peticionPostConHeader(`${this.urlDatosMaestros}/${url}/csv`, body, false);
  }

  report(query: Partial<VendedorQuery>): Observable<string> {
    return this._commom.peticionGetConHeader(`${this.urlDatosMaestros}/${url}/reporte?idRol=${query.idRol}`);
  }
}
